import { authFetch } from '../api/authFetch';
import type { EffortLevel } from './useModels';

interface TuningPatch {
  effort?: EffortLevel | null;
  enable1mContext?: boolean;
  model?: string;
}

interface TuningResponse {
  ok: true;
  effort: EffortLevel | null;
  enable1mContext: boolean;
  model?: string;
}

export async function patchSessionTuning(
  sessionId: string,
  patch: TuningPatch,
): Promise<TuningResponse> {
  const r = await authFetch(`/api/sessions/${encodeURIComponent(sessionId)}/tuning`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patch),
  });
  if (!r.ok) {
    const detail = await r.text().catch(() => '');
    throw new Error(`PATCH /sessions/${sessionId}/tuning failed: ${r.status} ${detail}`);
  }
  return r.json();
}
